// Integración de analítica para el landing.
// No hace nada hasta que se configuren las variables de entorno correspondientes,
// así el landing no dispara requests externos en desarrollo ni sin consentimiento real.
//
// Para activar Google Analytics 4:
//   REACT_APP_GA_MEASUREMENT_ID=G-XXXXXXXXXX
// Para activar Meta Pixel:
//   REACT_APP_META_PIXEL_ID=000000000000000

let initialized = false;

export function initAnalytics() {
  if (initialized) return;
  initialized = true;

  const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (gaId) {
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', gaId);
  }

  const pixelId = process.env.REACT_APP_META_PIXEL_ID;
  if (pixelId && !window.fbq) {
    /* eslint-disable */
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = true; n.version = '2.0';
      n.queue = []; t = b.createElement(e); t.async = true; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
  }
}

export function trackEvent(name, params) {
  if (window.gtag) window.gtag('event', name, params || {});
  if (window.fbq) window.fbq('trackCustom', name, params || {});
}
